// Pure, side-effect-free path helpers for the NovaCatering SDK. Split out from
// online-catering.ts so they can be unit-tested in isolation and so the SDK entry
// keeps a single default export (no mixed named/default IIFE export).

// Leading slash, no trailing slash: '/catering'. A base-path of '/' defeats the
// overlay, so callers should keep a real sub-path.
export const normalizeBase = (p: string): string =>
  '/' + String(p).replace(/^\/+|\/+$/g, '');

/**
 * Router-relative path each SDK entry navigates to. Catering serves a single Home
 * view at both "/" and "/menu"; there is NO locations/store route (store
 * selection is a modal inside the app), so the SDK exposes only home + menu.
 *   - 'home' → `<basePath>`            (e.g. "/catering")
 *   - 'menu' → `<basePath>/menu`
 */
export const buildCateringPath = (
  basePath: string,
  view: 'home' | 'menu' = 'home'
): string => (view === 'menu' ? `${basePath}/menu` : basePath);
